import cloneDeep from 'lodash.clonedeep';
import { mapChildren } from '@general/js/utils/JoinNow';

const mapChildrenPayload = (caiData) => {
  if (caiData.newCompositionHaveChildren) {
    let childrenObj;
    if (!caiData.oldCompositionHaveChildren) {
      childrenObj = cloneDeep(caiData.childrenStep.newChildren);
    } else {
      const remainingChildren = caiData.childrenStep.existingChildren.filter((child) => {
        if (caiData.childrenStep.terminations.length) {
          return !caiData.childrenStep.terminations.find((el) => {
            return el.personCode === child.personCode;
          });
        }
        return true;
      });
      childrenObj = [...remainingChildren, ...cloneDeep(caiData.childrenStep.newChildren)];
    }
    return mapChildren(childrenObj, true, true);
  }
  return null;
};

export default mapChildrenPayload;
